<div class="page-overflow">
  <div class="page-wrapper">
    <div id="login-left" class="login-left" #loginLeft>
      <div class="login-left-textos" *ngIf="loginLeft.style.backgroundImage">
        <img
          src="assets/imagens/logos/destaques/logo_destaque_1.png"
          draggable="false"
          alt=""
        />
        <h5>Venda Online</h5>
        <span>Venda seus produtos com praticidade, rapidez e segurança.</span>
      </div>
    </div>
    <div class="login-right">
      <div class="login-right-conteudo">
        <main class="login-area">
          <router-outlet></router-outlet>
        </main>
        <footer>
          <small>© Copyright 2024 G2. Todos os Direitos Reservados</small>
        </footer>
      </div>
    </div>
  </div>
</div>